module.exports = __webpack_public_path__ + "static/media/desktopScreenshot06.30291e57.jpg";